import React from 'react'
import CustomButton from '../../../../features/customButton/ui/main/CustomButton'
import StatusPanel from '../../../../baseComponents/gui/statusPanel/StatusPanel'
import { mainTopContent } from '../../../../../constants/copyright'
import { useRequests } from '../../../../../redux/reducer/requests'
import { useContent } from '../../../../../redux/reducer/content'
import { defaultStore } from '../../../../../translations'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import { RAFFLE } from '../../../../../constants/shared/states/names'

const {
  header: { addFriendButton },
  raffleText,
  raffleImage,
} = mainTopContent

const MainTop = React.forwardRef(function (_, ref) {
  const {
    authData: { isWeb },
  } = useRequests()
  const { raffle } = useContent()
  const gameTamagotchiBackToSchool = useFeatureToggle('gameTamagotchiBackToSchool')

  return (
    <div
      className={`main__header ${isWeb ? '' : 'app'}`}
      ref={ref}
    >
      <div className={classNames(`main__header-top main__header-top_${defaultStore}`)}>
        <CustomButton {...addFriendButton} />
        <StatusPanel
          type={'main'}
          noChangeFontSize={true}
        />
        <span className={'main__header-stub'} />
      </div>

      {gameTamagotchiBackToSchool && raffle && (
        <CSSTransition
          in={true}
          timeout={300}
          classNames={'main__button-raffle-wrapper'}
          mountOnEnter
          unmountOnExit
        >
          <div className={'main__button-raffle-wrapper'}>
            <CustomButton
              redirect={RAFFLE}
              className={'button_main-tickets main__button-raffle'}
              image={raffleImage}
              text={raffleText}
            />
          </div>
        </CSSTransition>
      )}

      {/*<div className={'main__button-drawing-result'}>*/}
      {/*  {defaultStore === stores.kz && isNewUser && <DrawingResultButton />}*/}
      {/*</div>*/}
    </div>
  )
})
export default MainTop
